export default function OrderFlag({ color, outline }: any) {
  return outline ? (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.2">
        <path
          d="M1.45 7.4L6.2 1.06667C6.6 0.533333 7.4 0.533333 7.8 1.06667L12.55 7.4C12.8167 7.75556 12.8167 8.24444 12.55 8.6L7.8 14.9333C7.4 15.4667 6.6 15.4667 6.2 14.9333L1.45 8.6C1.18333 8.24444 1.18333 7.75556 1.45 7.4Z"
          stroke={color}
        />
      </g>
    </svg>
  ) : (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.283313 7.4L5.03331 1.06667C5.43331 0.533333 6.23331 0.533333 6.63331 1.06667L11.3833 7.4C11.65 7.75556 11.65 8.24444 11.3833 8.6L6.63331 14.9333C6.23331 15.4667 5.43331 15.4667 5.03331 14.9333L0.283313 8.6C0.0166463 8.24444 0.0166463 7.75556 0.283313 7.4Z"
        fill={color}
      />
    </svg>
  );
}
